module.exports = __webpack_public_path__ + "static/media/preloader.6e73cf40.svg";